export const REGEX = {
  email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  phone: /^\+?[\d\s\-()]{10,}$/,
  password: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?!.*\s)[^\s]{8,}$/,
  passwordLength: /^[^\s]{8,}$/,
  passwordUppercase: /(?=.*[A-Z])/,
  passwordDigit: /(?=.*\d)/,
  passwordSpecial: /(?=.*[!@#$%^&*])/,
  name: /^[a-zA-Z\s]{2,50}$/,
  alphanumeric: /^[a-zA-Z0-9]+$/,
  numeric: /^\d+$/,
  url: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/,
  timeFormat: /^(\d+h\s*\d+m|\d+h|\d+m)$/i,
  minutes: /(\d+)m/i,
  nonAlphanumeric: /[^a-zA-Z0-9]/g,
  nonAlphanumericWithSpaces: /[^a-zA-Z0-9\s]/g,
  dependencyTypeToken: /[^A-Z0-9]+/g,
  botToken: /^[a-zA-Z0-9_-]+$/,
  emailWhitespace: /\s/g,
  emailInvisibleChars: /[\u200B-\u200D\uFEFF]/g,
  htmlTags: /<[^>]*>/g,
  htmlEntities: /&lt;|&gt;|&amp;|&nbsp;/g,
  historyQuotesContent: /"([^"]*)"/g,
  historyActionNames: /(?:added|removed)\s+(.*?)\s+(?:to|from)/,
  hexColor: /^#[0-9A-Fa-f]{6}$/,
  sprintText: /^[a-zA-Z0-9\s\-_.,]*$/,
  nonNumeric: /[^0-9]/g
};